import { NgModule, Optional, SkipSelf } from "@angular/core";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { FuseAlertComponent } from "@fuse/components/alert/alert.component";
import { AuthModule } from "app/core/auth/auth.module";
import { IconsModule } from "app/core/icons/icons.module";

@NgModule({
  imports: [
    AuthModule,
    IconsModule,
    MatSnackBarModule,
    FuseAlertComponent,
  ],
})
export class CoreModule {
  /**
   * Constructor
   */
  constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
    // Do not allow multiple injections
    if (parentModule) {
      throw new Error(
        "CoreModule has already been loaded. Import this module in the AppModule only."
      );
    }
  }
}
